export const SIDE_BAR_COLLAPSED = "sidebarCollapsed";

// Guarded because the reducer calls this at module-eval time, where a throw would stop
// the bundle from booting and no error boundary could catch it.
export const getStoredSidebarCollapsed = () => {
  try {
    const stored = localStorage.getItem(SIDE_BAR_COLLAPSED);
    return stored ? JSON.parse(stored) : true;
  } catch (e) {
    return true;
  }
};
